import { Col, Row } from 'react-bootstrap';
import { Link } from 'wouter';
import { AccordionSection } from '@medifind/containers';
import { toSlug } from '@medifind/router';
import { Skeleton } from '@medifind/shared-basic-components';
import styles from './ClinicalTrialShared.module.scss';

const ClinicalTrialRelatedConditions = ({ conditions, isLoading }) => {
  return (
    <AccordionSection
      classes={{
        container: styles['accordian-container'],
        header: styles['accordian-header'],
        title: styles['accordian-title'],
        body: styles['accordian-body'],
      }}
      expandable
      title="Related Therapeutic Areas"
      isLoading={isLoading}
    >
      {conditions ? (
        conditions.map(({ termName, projectId }, i) => {
          const codingSlugInner = toSlug(termName);
          const conditionHref = `/conditions/${codingSlugInner}/${projectId}`;
          return (
            <Row key={i}>
              <Col>{process.env.NX_APP === 'MediFind' ? <Link to={conditionHref}>{termName}</Link> : termName}</Col>
            </Row>
          );
        })
      ) : (
        <Skeleton count={6} />
      )}
    </AccordionSection>
  );
};

export { ClinicalTrialRelatedConditions as default, ClinicalTrialRelatedConditions };
